module.exports = __webpack_public_path__ + "static/Lato-Bold-d878b6c29b10beca227e9eef4246111b.woff";